customElements.component = 'new-all-events';

if(!customElements.get(customElements.component)){

  class newAllEvents extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {
      this.setHeaderHeight();
      this.initListeners();
      this.resizeSwipers();
        
      let scrollPosition = window.scrollY || document.documentElement.scrollTop;

      if (scrollPosition > 10) {
        document.body.classList.add("sticky");
      } else {
        document.body.classList.remove("sticky");
      }

      window.addEventListener('scroll', () => {
        scrollPosition = window.scrollY || document.documentElement.scrollTop;

        if (scrollPosition > 10) {
          document.body.classList.add("sticky");
        } else {
          document.body.classList.remove("sticky");
        }
      });
    }

    setHeaderHeight() {
      const header = document.querySelector('#shopify-section-header');
      this.headerInitialHeight = header.offsetHeight;
    }

    initListeners() {
      window.addEventListener('resize', this.resizeSwipers.bind(this));

      const componentTabs = this.querySelector('component-tabs');
      if(componentTabs) componentTabs.addEventListener('switch-tabs', () => {
        this.resizeSwipers();
      });
    }

    resizeSwipers() {
      const pageComponents = this.getAllPageComponents();
      const totalComponentsHeight = this.setTotalComponentsHeight(pageComponents);
      
      const spaceBetweenSliderFooter = 20;
      const amountToSubtract = totalComponentsHeight + spaceBetweenSliderFooter;

      const contentInsideSwiperCard = this.getContentInsideSwiperCard();
      const newSwpHeight = `calc(${pageComponents.body.offsetHeight}px - ${amountToSubtract}px)`;
      const heights = {
        newSwpHeight: newSwpHeight,
        newImgHeight: this.getNewImageHeight(newSwpHeight, contentInsideSwiperCard)
      }

      this.setNewHeights(heights);
    }

    getContentInsideSwiperCard() {
      const eventHeadingWrapper = this.querySelector('.tabs__heading-wrapper.events-page-tabs');
      if(eventHeadingWrapper) {
        return {
          menuMobileText: this.querySelector('.tabs__content.active .new-all-events .menu__submenu-mobile'),
          menuDesktopText: this.querySelector('.tabs__content.active .new-all-events .menu__submenu-desktop'),
          defaultEventMessage: this.querySelector('.tabs__content.active .new-all-events .default_event_message')
        }
      } 
      return {
        menuMobileText: this.querySelector('.new-all-events .menu__submenu-mobile'),
        menuDesktopText: this.querySelector('.new-all-events .menu__submenu-desktop')
      }
    }

    getDefaultEventMessageHeight(defaultEventMessage) {
      const spaceBetweenDefaultEventMessageAndSwiperCard = 32;
      if(this.isDefaultEventMessageAtTheBottom(defaultEventMessage)) 
        return defaultEventMessage.offsetHeight + spaceBetweenDefaultEventMessageAndSwiperCard;
      return 0;
    }

    getNewImageHeight(swpHeight, swpCardContent) {
      const gapBetweenImageAndMenuTextMobile = 8;
      const gapBetweenImageAndMenuTextDesktop = 20;
      if(this.isMenuMobileTextHidden(swpCardContent.menuMobileText) && swpCardContent.menuDesktopText) {
        return `calc((${swpHeight}) - ${swpCardContent.menuDesktopText.offsetHeight}px - ${gapBetweenImageAndMenuTextDesktop}px)`; 
      } else if (swpCardContent.menuMobileText) {
        return `calc((${swpHeight}) - ${swpCardContent.menuMobileText.offsetHeight}px - ${gapBetweenImageAndMenuTextMobile}px)`;
      }
      
    }

    isDefaultEventMessageAtTheBottom(defaultEventMessage) {
      return defaultEventMessage ? window.getComputedStyle(defaultEventMessage).getPropertyValue('position') === 'relative' : false;
    }

    isMenuMobileTextHidden(menuMobileText) {
      return menuMobileText ? window.getComputedStyle(menuMobileText).getPropertyValue('display') === 'none' : true;
    }

    setNewHeights(heights) {
      const eventImages = this.querySelectorAll('.event-image.with-event img');
      const swiperWrappers = this.querySelectorAll('.swiper-wrapper');

      eventImages.forEach((img) => {
        img.style.height = heights.newImgHeight;
      });
      swiperWrappers.forEach((swiperWrapper) => {
        if(this.swiperHasOneItem(swiperWrapper)) {
          const paddingBottom = 20;
          const defaultEventMessage = swiperWrapper.querySelector('.default_event_message');
          const defaultEventMessageHeight = this.getDefaultEventMessageHeight(defaultEventMessage);
          const footer = document.querySelector('#shopify-section-footer');
          const image = swiperWrapper.querySelector('.event-image.with-event img');

          if(window.innerWidth <= 1024 && image) {
            image.style.height = `calc(${this.getNewImageHeight(heights.newSwpHeight, this.getContentInsideSwiperCard())} + ${footer.offsetHeight}px)`;
            swiperWrapper.style.height = `calc(${heights.newSwpHeight} + ${defaultEventMessageHeight}px + ${footer.offsetHeight}px + ${paddingBottom}px)`;
          } else swiperWrapper.style.height = `calc(${heights.newSwpHeight} + ${paddingBottom}px)`;
        } 
        else {
          const images = swiperWrapper.querySelectorAll('.event-image.with-event img');

          if(window.innerWidth <= 1300 && images.length > 0) {
            const paddingBottom = 20;
            const footer = document.querySelector('#shopify-section-footer');
            images.forEach((image) => {
              image.style.height = `calc(${this.getNewImageHeight(heights.newSwpHeight, this.getContentInsideSwiperCard())} + ${footer.offsetHeight}px)`;
            });
            swiperWrapper.style.height = `calc(${heights.newSwpHeight} + ${footer.offsetHeight}px + ${paddingBottom}px)`;
          }
          else swiperWrapper.style.height = heights.newSwpHeight;
        }
      });
    }

    swiperHasOneItem(swiperWrapper) {
      const swiperSlides = swiperWrapper.querySelectorAll('.swiper-slide');
      return swiperSlides.length === 1;
    }

    getAllPageComponents() {
      return {
        body: document.querySelector('body'),
        header: document.querySelector('#shopify-section-header'),
        eventHeaderBanner: document.querySelector('.events-header__banner'),
        footer: document.querySelector('#shopify-section-footer'),
      }
    }

    setTotalComponentsHeight(pageComponents) {
      const headerHeight = this.headerInitialHeight;
      const totalComponentsHeight = headerHeight + pageComponents.footer.offsetHeight + pageComponents.eventHeaderBanner.offsetHeight;
      const eventHeadingWrapper = this.isOnlineEventsPage() ? document.querySelector('.tabs__heading-wrapper.online-events-page-tabs') : this.querySelector('.tabs__heading-wrapper.events-page-tabs');
      if(eventHeadingWrapper) return totalComponentsHeight + eventHeadingWrapper.offsetHeight;
      return totalComponentsHeight;
    }

    isOnlineEventsPage() {
      return document.querySelector('body.template-type-page-shop-all-online-events') ? true : false;
    }
  }

  customElements.define(customElements.component, newAllEvents); 
}
